<template>
  <WdsModal
    no-close-icon
    :show="show"
    :title="$t('Delete this timesheet?')"
    :subtitle="$t('This will remove the timesheet from the payment request.')"
    class="tw-px-8.5"
    @cancel="emit('cancel')"
  >
    <template #header>
      <div>
        <WdsText xl>{{ $t('Delete this timesheet?') }}</WdsText>
        <WdsText secondary>
          {{ $t('This timesheet will be permanently deleted') }}
        </WdsText>
      </div>
    </template>
    <template #footer>
      <div class="tw-flex tw-justify-end">
        <WdsStack gap-sm>
          <WdsButton default @click="emit('cancel')">{{ $t('Back to editor') }}</WdsButton>
          <WdsButton :disabled="working" error @click="emit('delete-timesheet')">
            {{ working ? $t('Deleting...') : $t('Delete') }}
          </WdsButton>
        </WdsStack>
      </div>
    </template>
  </WdsModal>
</template>

<script setup lang="ts">
import { WdsButton, WdsModal, WdsStack, WdsText } from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'

withDefaults(
  defineProps<{
    show?: boolean
    working?: boolean
  }>(),
  {
    show: false,
    working: false,
  },
)

const emit = defineEmits(['cancel', 'delete-timesheet'])

const { $t } = useTranslation()
</script>

<style scoped>
:deep(.wds-modal-body) {
  margin: 0 !important;
}
</style>
